<template lang="pug">
    .reaction
        Input(
            v-if="inputType=='text'"
            :inputType="inputType"
            :content="content"
            :information="information"
            :answered="answered"
            :reaction="reaction"
            :section="section"
        )
        Radio(
            v-else-if="inputType=='radio'"
            :inputType="inputType"
            :content="content"
            :information="information"
            :answered="answered"
            :reaction="reaction"
            :section="section"
            :answer="answer"
        )
        Checkbox(
            v-else-if="inputType=='checkbox'"
            :inputType="inputType"
            :content="content"
            :information="information"
            :answered="answered"
            :reaction="reaction"
            :section="section"
        )
        .nextInformation(
            v-else-if="inputType=='next'"
        )
        Button(
            v-if="reaction.wait==true"
            :wait="reaction.wait"
        )
</template>
<script>
    import _ from 'lodash'

    import Input from './InputTypes/Input'
    import Radio from './InputTypes/Radio'
    import Checkbox from './InputTypes/Checkbox'
    import Button from './InputTypes/Button'

    export default {
        name: 'Reaction',
        props: {
            reaction: {
                type: Object,
                required: true,
            },
            information: {
                type: Object,
                required: true
            },
            answered: {
                type: Boolean
            },
            section: {
                type: Object,
                required: true
            },
            answer: {
                type: undefined
            }
        },
        components: {
            Input,
            Radio,
            Checkbox,
            Button
        },
        computed: {
            contents() {
                return this.reaction.contents || []
            },
            heading() {
                return this.contents.find(content => content.key === 'heading')
            },
            content() {
                return this.contents.find(content => content.key === 'reaction-option')
            },
            images() {
                return this.contents.filter(content => content.key === 'reaction-image')
            },
            inputType() {
                switch(this.reaction.input_type) {
                    case 'single_choice':
                    case 'single-choice':
                    case 'singlechoice':
                    case 'radio':
                    case 'single':
                        return 'radio'
                        break
                    case 'select':
                    case 'multiple':
                    case 'multiple-choice':
                    case 'multiple_choice':
                    case 'multiplechoice':
                    case 'checkbox':
                        return 'checkbox'
                        break
                    case 'input':
                    case 'text':
                    case 'freetext':
                        return 'text'
                        break
                    case 'nextInformation':
                    case 'next-information':
                    case 'nextinformation':
                        return 'next'
                        break
                    default:
                        return 'text'
                        break
                }
            },
        }
    }
</script>
<style lang="sass">
    
</style>
